<template>
  <div class="bg-white position-fixed start-0 w-100 shadow" style="top: 134px; z-index: 2">
    <ul class="nav container flex justify-content-between flex-nowrap text-nowrap">
      <template v-for="(link, index) in links" :key="index">
        <li class="nav-item">
          <router-link
            v-slot="{ isActive }"
            class="nav-link p-0 ps-0 ps-xl-2 d-flex align-items-center rounded-0"
            :to="{ name: link.name, params: { menuid: $route.params.menuid } }"
            active-class="active"
            :class="{ disabled: link.meta.disabled }"
          >
            <i
              class="d-none d-xl-inline-flex bi fs-4 m-2 ms-0 rounded-circle border border-2 align-items-center justify-content-center"
              style="width: 2.5rem; height: 2.5rem"
              :class="[
                link.iconClass,
                link.meta.disabled ? 'border-gray' : 'border-primary',
                isActive && 'bg-primary text-white',
              ]"
            ></i>
            <span class="fs-5" :class="isActive && 'text-decoration-underline'">
              {{ index + 1 }}. {{ link.text }}
            </span>
          </router-link>
        </li>
        <li v-if="index + 1 < links.length" class="nav-item d-inline-flex align-items-center" style="opacity: 0.25">
          <i class="bi bi-chevron-right fs-2 d-none d-xl-inline"></i>
          <i class="bi bi-chevron-right fs-6 d-xl-none"></i>
        </li>
      </template>
    </ul>
    <help-video-button></help-video-button>
  </div>
</template>

<script>
import HelpVideoButton from '@/components/HelpVideoButton';

export default {
  components: {
    HelpVideoButton,
  },
  props: {
    links: {
      type: Array,
      default: null,
    },
  },
  setup() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.border-gray {
  border-color: rgb(108, 117, 125) !important;
}
.shadow {
  box-shadow: -8rem -8rem 0 8rem #fff, 8rem -8rem 0 8rem #fff, 0 -8rem 1rem 8rem rgba(0, 0, 0, 0.25) !important;
}
</style>
